import React from "react";
import { pick } from "lodash";
// import { isGiftCardPageEnabled } from './enabledFeatureChecks'
import RestPlusCopy from "../components/Atoms/RestPlusCopy";
import { ReactComponent as FacebookLogo } from "../images/facebook-logo.svg";
import { ReactComponent as InstagramLogo } from "../images/instagram-logo.svg";
import { ReactComponent as TwitterLogo } from "../images/twitter-logo.svg";
import {
  REST_2ND_GEN_KEY,
  RESTORE_KEY,
  WHOOP_RESTORE_KEY,
} from "./productConstants";
import VisuallyHidden from "@reach/visually-hidden";

export const IMGIX_BASE_PATH = "https://hatchbaby.imgix.net/webassets";
export const IMGIX_SHOPIFY_BASE_PATH = "https://hatch-shopify.imgix.net";
export const SHOPIFY_BASE_URL = `https://${process.env.REACT_APP_SHOPIFY_STORE}`;
export const SHOPIFY_ADD_TO_CART_URL = `${SHOPIFY_BASE_URL}/cart`;
export const HATCH_LEVER_JOBS_URL = "https://jobs.lever.co/hatch";
export const ZENDESK_SUPPORT_PAGE_URL =
  "https://hatchbaby.zendesk.com/hc/en-us";
// export const RETURNS_PAGE_URL = 'https://shop.hatchbaby.com/apps/returns'
export const BUILDER_CHECKOUT_SESSION_ID_KEY = "_builderSessionId";
export const MAILCHIMP_RESTORE_SIGNUP_URL =
  "https://hatch.us10.list-manage.com/subscribe/post?u=2013bf3158cce6fb1525a5da8&amp;id=9ad4f4c9c9";
export const MAILCHIMP_EMAIL_CAPTURE_URL =
  "https://hatchbaby.us10.list-manage.com/subscribe/post?u=2013bf3158cce6fb1525a5da8&amp;id=51f5f80034";
export const AMAZON_PIXEL_PARAMS = {
  homepage:
    "ex-fargs=%3Fid%3D888bdb43-241d-fd00-2cca-22cc1720a5bf%26type%3D55%26m%3D1&ex-fch=416613&ex-src=https://www.hatch.co/&ex-hargs=v%3D1.0%3Bc%3D6214354400401%3Bp%3D888BDB43-241D-FD00-2CCA-22CC1720A5BF",
  restorePage:
    "ex-fargs=%3Fid%3D7f301c58-d0a5-9d72-ede8-3d2bf7312252%26type%3D4%26m%3D1&ex-fch=416613&ex-src=https://www.hatch.co/restore&ex-hargs=v%3D1.0%3Bc%3D6214354400401%3Bp%3D7F301C58-D0A5-9D72-EDE8-3D2BF7312252",
};

export const MOBILE = "mobile";
export const WIDE_MOBILE = "wideMobile";
export const TABLET = "tablet";
export const DESKTOP = "desktop";
export const WIDE = "wide";

export const BREAKPOINT_KEYS = {
  MOBILE,
  WIDE_MOBILE,
  TABLET,
  DESKTOP,
  WIDE,
};

export const BREAKPOINT_PIXEL_VALUES = {
  [BREAKPOINT_KEYS.WIDE_MOBILE]: 480,
  [BREAKPOINT_KEYS.TABLET]: 768,
  [BREAKPOINT_KEYS.DESKTOP]: 1024,
  [BREAKPOINT_KEYS.WIDE]: 1200,
};

export const BREAKPOINTS = {
  [BREAKPOINT_KEYS.WIDE_MOBILE]: `(min-width: ${
    BREAKPOINT_PIXEL_VALUES[BREAKPOINT_KEYS.WIDE_MOBILE]
  }px)`,
  [BREAKPOINT_KEYS.TABLET]: `(min-width: ${
    BREAKPOINT_PIXEL_VALUES[BREAKPOINT_KEYS.TABLET]
  }px)`,
  [BREAKPOINT_KEYS.DESKTOP]: `(min-width: ${
    BREAKPOINT_PIXEL_VALUES[BREAKPOINT_KEYS.DESKTOP]
  }px)`,
  [BREAKPOINT_KEYS.WIDE]: `(min-width: ${
    BREAKPOINT_PIXEL_VALUES[BREAKPOINT_KEYS.WIDE]
  }px)`,
};

export const EMAIL_ADDRESSES = {
  support: "support@hatch.co",
  jobs: "jobs@hatchbaby.com",
  press: "press@hatchbaby.com",
};

export const DOWNLOAD_LINKS = {
  restPlusManual:
    "https://hatchbaby-public.s3-us-west-2.amazonaws.com/misc/Rest-Plus-Instruction-Manual-1.pdf",
  pressKit: "https://drive.google.com/file/d/1fU-8Vvupv1u-raxJNpAa5W8_lqRk4Z6m",
};

export const ABOUT_US_PRESS_LINKS = [
  {
    name: "Yahoo",
    logo: "yahoo-logo.svg",
    link: "https://news.yahoo.com/shocking-number-mornings-americans-wake-143600197.html",
  },
  {
    name: "PopSugar",
    logo: "popsugar-logo-homepage.svg",
    link: "https://www.popsugar.com/family/best-baby-gear-2020-45632058",
  },
  {
    name: "Goop",
    logo: "goop-logo.svg",
    link: "https://goop.com/style/gift-guides/holiday-gifts-for-kids/?ref=newsletter",
  },
  {
    name: "TodayShow",
    logo: "today-logo.svg",
    link: "https://www.today.com/parents/7-genius-products-every-parent-needs-get-kids-out-door-t159394",
  },
];

export const SEO_META_TAGS = {
  title: "Hatch",
  siteName: "Hatch, Inc",
  image: `${IMGIX_BASE_PATH}/hatch-logo-social.jpg`,
  descriptions: {
    home: "Better sleep for everyone. Soothing white noise sound machine, wake up light, sunrise alarm clock, baby and toddler night light. Free shipping & returns!",
    dreamShopLanding:
      "Welcome to the dream shop - what we use, love, and obsess over for great sleep",
  },
};

export const SEO_STRUCTURED_PRODUCT_DATA = {
  [REST_2ND_GEN_KEY]: {
    description:
      "The super-smart, do-it-all sleep device that you can control from your phone, offering a sound machine, night light, and time-to-rise functionality.",
    upc: "852852007627",
    sku: "HBR4400",
    name: "Hatch Rest 2nd Generation",
    image: `${IMGIX_BASE_PATH}/riot-cart-image-192x192.jpg`,
    url: "https://www.hatch.co/rest",
  },
  rest: {
    description:
      "The super-smart, do-it-all sleep device that you can control from your phone, offering a sound machine, night light, and time-to-rise functionality.",
    upc: "852852007009",
    sku: "HBR16001WHT",
    name: "Hatch Rest",
    image: `${IMGIX_BASE_PATH}/rest-feature-1.jpg`,
    url: "https://www.hatch.co/rest",
  },
  rest_plus: {
    description:
      "The super-smart, do-it-all sleep device that you can control from your phone, offering a sound machine, night light, time-to-rise, and audio monitor functionality.",
    upc: "852852007399",
    sku: "HBR2700",
    name: "Hatch Rest+",
    image: `${IMGIX_BASE_PATH}/rest-plus-gallery-1.jpg`,
    url: "https://www.hatch.co/rest-plus",
  },
  [RESTORE_KEY]: {
    description:
      "The super-smart, do-it-all sleep device that you can control from your phone, offering a sound machine, sunrise alarm, smart light, meditation app, and an alarm clock into one smart sleep assistant.",
    upc: "852852007559",
    sku: "HBR4100",
    name: "Hatch Restore",
    image: `${IMGIX_BASE_PATH}/restore-light-fall-asleep-fast.png`,
    url: "https://www.hatch.co/restore",
  },
  [WHOOP_RESTORE_KEY]: {
    description:
      "The super-smart, do-it-all sleep device that you can control from your phone, offering a sound machine, sunrise alarm, smart light, meditation app, and an alarm clock into one smart sleep assistant.",
    upc: "852852007702",
    sku: "HBR4100WHT",
    name: "Hatch Restore",
    image: `${IMGIX_BASE_PATH}/restore-whoop-sleep-membership.jpg`,
    url: "https://www.hatch.co/restorehsm",
  },
};

export const BROWSER_VIEW_MAP = {
  firefox: {
    name: "firefox",
    className: "is_firefox",
  },
  safari: {
    name: "safari",
    className: "is_safari",
  },
  chrome: {
    name: "chrome",
    className: "is_chrome",
  },
  webview: {
    name: ["CustomTab", "WebView"],
    className: "is_webview",
  },
  default: {
    name: "",
    className: "",
  },
};

export const DEVICE_OS_MAP = {
  iOS: {
    iPhone: {
      name: "iPhone",
      className: "is_iphone is_ios",
      view: {
        ...BROWSER_VIEW_MAP,
      },
    },
    iPhoneX: {
      name: "iPhoneX",
      className: "is_iphone_x is_ios",
      view: {
        ...BROWSER_VIEW_MAP,
      },
    },
    iPad: {
      name: "iPad",
      className: "is_ipad is_ios",
      view: {
        ...BROWSER_VIEW_MAP,
      },
    },
  },
  android: {
    className: "is_android",
    name: "android",
    view: {
      ...pick(BROWSER_VIEW_MAP, ["chrome", "webview", "firefox"]),
    },
  },
  macOS: {
    className: "is_mac_desktop",
    name: "macDesktop",
    view: {
      ...BROWSER_VIEW_MAP,
    },
  },
  windows: {
    className: "is_windows",
    name: "windows",
    view: {
      ...BROWSER_VIEW_MAP,
    },
  },
  default: {
    className: "",
    name: "",
  },
};

export const FOOTER_COMPANY_PAGE_LINKS = [
  {
    displayName: "About",
    linkProps: { to: "/about-us" },
  },
  {
    displayName: "Blog",
    linkProps: { to: "/blog" },
  },
  {
    displayName: "Support",
    linkProps: { href: ZENDESK_SUPPORT_PAGE_URL },
  },
  // {
  //   displayName: 'Returns',
  //   linkProps: { href: RETURNS_PAGE_URL },
  // },
  {
    displayName: "Returns",
    linkProps: { href: "https://shop.hatchbaby.com/apps/returns" },
  },
  {
    displayName: "Hatch For Work",
    linkProps: { to: "/hatch-for-work" },
  },
];

export const FOOTER_LEGAL_LINKS = [
  {
    displayName: "Privacy",
    linkProps: { to: "/privacy-policy" },
  },
  {
    displayName: <>Terms &amp; Conditions</>,
    name: "Terms & Conditions",
    linkProps: { to: "/terms" },
  },
];

export const FOOTER_PRODUCT_LINKS = [
  {
    displayName: "Restore",
    linkProps: {
      to: "/restore",
      title: "Visit the Restore product page",
    },
  },
  {
    displayName: <RestPlusCopy />,
    linkProps: {
      to: "/rest-plus",
      title: "Visit the Rest Plus product page",
    },
  },
  {
    displayName: "Rest",
    linkProps: { to: "/rest", title: "Visit the Rest product page" },
  },
  // {
  //   displayName: 'Rest (2nd Gen)',
  //   linkProps: { to: '/restsecondgen' },
  // },
  {
    displayName: "Rest Mini",
    linkProps: {
      to: "/rest-mini",
      title: "Visit the Rest Mini product page",
    },
  },
  {
    displayName: "Coverlets",
    linkProps: { to: "/dream-shop/coverlets" },
  },
  {
    displayName: "Cloud Pillow",
    linkProps: { to: "/dream-shop/hatch-cloud-pillow" },
  },
  {
    displayName: "Grow",
    linkProps: { href: `${SHOPIFY_BASE_URL}/products/grow` },
  },
  {
    displayName: (
      <>
        Accessories<VisuallyHidden>&nbsp;Product Page</VisuallyHidden>
      </>
    ),
    linkProps: {
      to: "/accessories",
    },
  },
  // isGiftCardPageEnabled() ? {
  //   displayName: 'Gift Cards',
  //   linkProps: { to: '/hatch-gift-cards' },
  // } : {},
];

export const SOCIAL_MEDIA_LINKS = [
  {
    title: "Instagram",
    logo: <InstagramLogo className="icon" />,
    linkProps: {
      href: "https://www.instagram.com/hatchforsleep",
      className: "social_icon_link",
    },
  },
  {
    title: "Facebook",
    logo: <FacebookLogo className="icon" />,
    linkProps: {
      href: "https://www.facebook.com/hatchforsleep",
      className: "social_icon_link",
    },
  },
  {
    title: "Twitter",
    logo: <TwitterLogo className="icon" />,
    linkProps: {
      href: "https://twitter.com/hatchforsleep",
      className: "social_icon_link",
    },
  },
];

export const KIDS_GROUP_KEYS = {
  NEWBORNS: "newborns",
  BABIES: "babies",
  LITTLE_KIDS: "littleKids",
  BIG_KIDS: "bigKids",
};

export const RESTORE_HOW_IT_WORKS_KEYS = {
  FALL_ASLEEP: "fallAsleep",
  STAY_ASLEEP: "stayAsleep",
  WAKE_UP: "wakeUp",
};

const Constants = {
  DEVICE_OS_MAP,
  SHOPIFY_BASE_URL,
  IMGIX_BASE_PATH,
  IMGIX_SHOPIFY_BASE_PATH,
  // Grid System
  MAX_NUMBER_COLUMNS: 12,
  BREAKPOINT_SIZES: ["xs", "sm", "md", "lg", "xl"],
  DEFAULT_COLUMN_PROP_VALUES: {
    cols: 1,
    offset: 0,
    startPos: 1,
    endPos: 2,
    noLeftGutter: false,
    noRightGutter: false,
    newRow: false,
  },
  // Login / Sign Up pages
  GRID_COLUMNS: {
    xl: 12,
    lg: 12,
    md: 12,
    sm: 12,
    xs: 12,
  },
  // Taken from https://stackoverflow.com/questions/205923/best-way-to-handle-security-and-avoid-xss-with-user-entered-urls
  UNSAFE_URL_CHARACTERS: new RegExp(/[^-A-Za-z0-9+&@#%/?=~_|!:,.;()]/g),
};

export default Constants;
